function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1936(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.76,
    height: 15.25,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1730769230769231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 7.625
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.25,
    width: 24.76,
    height: 22.34,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.723333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 26.42
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 37.6,
    width: 24.76,
    height: 23.69,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 49.445
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 61.29,
    width: 24.76,
    height: 24.23,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 73.405
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85.52,
    width: 24.76,
    height: 24.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 97.705
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 109.88,
    width: 24.76,
    height: 25.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5371428571428574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 122.5
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.13,
    width: 24.76,
    height: 28.42,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5371428571428574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 149.34
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 163.54,
    width: 24.76,
    height: 29.5,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 178.29
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.04,
    width: 24.76,
    height: 29.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 207.89
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 222.74,
    width: 24.76,
    height: 31.18,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 238.33
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.92,
    width: 24.76,
    height: 32.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 270.21999999999997
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 286.52,
    width: 24.76,
    height: 33.21,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.253333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 303.125
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 319.73,
    width: 24.76,
    height: 33.55,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 336.505
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 353.27,
    width: 24.76,
    height: 33.68,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 370.10999999999996
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 386.95,
    width: 24.76,
    height: 35.84,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.952
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 404.87
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 422.79,
    width: 24.76,
    height: 37.06,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 441.32000000000005
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 459.85,
    width: 24.76,
    height: 38.47,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5371428571428574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 479.08500000000004
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 498.32,
    width: 24.76,
    height: 38.54,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 517.59
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 536.86,
    width: 24.76,
    height: 38.61,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 556.165
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 575.47,
    width: 24.76,
    height: 38.68,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.476
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 594.8100000000001
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 614.15,
    width: 24.76,
    height: 41.37,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.952
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 634.8349999999999
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 655.52,
    width: 24.76,
    height: 44.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.38,
    y: 677.76
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 0,
    width: 32.11,
    height: 34.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.587142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.815,
    y: 17.335
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.87,
    y: 0,
    width: 32.83,
    height: 34.67,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.285,
    y: 17.335
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.7,
    y: 0,
    width: 32.88,
    height: 34.67,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.14,
    y: 17.335
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.58,
    y: 0,
    width: 33.21,
    height: 34.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.744285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.185,
    y: 17.335
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.79,
    y: 0,
    width: 33.26,
    height: 34.67,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.543333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.42,
    y: 17.335
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.05,
    y: 0,
    width: 33.7,
    height: 34.67,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.9,
    y: 17.335
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.75,
    y: 0,
    width: 33.7,
    height: 34.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.616666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.6,
    y: 17.335
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 0,
    width: 33.74,
    height: 34.67,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.32,
    y: 17.335
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.19,
    y: 0,
    width: 34.71,
    height: 34.67,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.33375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.545,
    y: 17.335
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.9,
    y: 0,
    width: 34.9,
    height: 34.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.467
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.34999999999997,
    y: 17.335
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 0,
    width: 36.4,
    height: 34.67,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.852222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378,
    y: 17.335
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.2,
    y: 0,
    width: 36.4,
    height: 34.67,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.778333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.4,
    y: 17.335
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.6,
    y: 0,
    width: 36.64,
    height: 34.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.934
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.92,
    y: 17.335
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.23,
    y: 0,
    width: 37.17,
    height: 34.67,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.934
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.815,
    y: 17.335
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.4,
    y: 0,
    width: 37.46,
    height: 34.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.952857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.13,
    y: 17.335
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.86,
    y: 0,
    width: 38.23,
    height: 34.67,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.952857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.975,
    y: 17.335
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.09,
    y: 0,
    width: 39,
    height: 34.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.33375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.59,
    y: 17.335
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.08,
    y: 0,
    width: 39.43,
    height: 34.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.852222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.7950000000001,
    y: 17.335
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.52,
    y: 0,
    width: 39.48,
    height: 34.67,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.952857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.26,
    y: 17.335
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 34.67,
    width: 37.59,
    height: 36.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 52.945
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 71.22,
    width: 37.59,
    height: 36.86,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.372
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 89.65
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 108.07,
    width: 37.59,
    height: 37.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 126.585
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 145.11,
    width: 37.59,
    height: 37.12,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1866666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 163.67000000000002
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 182.23,
    width: 37.59,
    height: 37.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 200.97
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 219.71,
    width: 37.59,
    height: 37.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 238.45000000000002
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 257.19,
    width: 37.59,
    height: 37.92,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.518000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 276.15
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 295.11,
    width: 37.59,
    height: 37.97,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 314.095
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 333.08,
    width: 37.59,
    height: 39.26,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.518000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 352.71
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 372.34,
    width: 37.59,
    height: 39.97,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.518000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 392.325
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 412.31,
    width: 37.59,
    height: 40.41,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.518000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 432.515
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 452.72,
    width: 37.59,
    height: 40.5,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 472.97
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 493.22,
    width: 37.59,
    height: 40.55,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 513.495
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 533.77,
    width: 37.59,
    height: 40.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.265000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 554.245
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 574.71,
    width: 37.59,
    height: 41.17,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 595.2950000000001
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 615.88,
    width: 37.59,
    height: 41.61,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 636.685
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 657.5,
    width: 37.59,
    height: 42.5,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.265000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.55500000000001,
    y: 678.75
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 34.67,
    width: 39.46,
    height: 40.83,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.946
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.09,
    y: 55.085
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.82,
    y: 34.67,
    width: 40.32,
    height: 40.83,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.97999999999999,
    y: 55.085
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.13,
    y: 34.67,
    width: 40.4,
    height: 40.83,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.32999999999998,
    y: 55.085
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.53,
    y: 34.67,
    width: 40.56,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.81,
    y: 55.085
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.1,
    y: 34.67,
    width: 41.26,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.73,
    y: 55.085
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.36,
    y: 34.67,
    width: 41.3,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.832857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.01,
    y: 55.085
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.66,
    y: 34.67,
    width: 42.32,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.083
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.82000000000005,
    y: 55.085
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.98,
    y: 34.67,
    width: 42.9,
    height: 40.83,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.43,
    y: 55.085
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.88,
    y: 34.67,
    width: 43.1,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.166
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.43,
    y: 55.085
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.98,
    y: 34.67,
    width: 43.47,
    height: 40.83,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.2075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.71500000000003,
    y: 55.085
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.45,
    y: 34.67,
    width: 44,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.832857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.45,
    y: 55.085
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.45,
    y: 34.67,
    width: 44,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.45,
    y: 55.085
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.46,
    y: 34.67,
    width: 44.33,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.625,
    y: 55.085
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.79,
    y: 34.67,
    width: 44.78,
    height: 40.83,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.166
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.18,
    y: 55.085
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 654.57,
    y: 34.67,
    width: 45.43,
    height: 40.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.166
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.2850000000001,
    y: 55.085
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 75.5,
    width: 45.65,
    height: 40.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.134
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 95.83500000000001
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 116.18,
    width: 45.65,
    height: 41.08,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.846666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 136.72
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 157.25,
    width: 45.65,
    height: 41.77,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.354000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 178.135
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 199.03,
    width: 45.65,
    height: 42.36,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.472
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 220.21
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 241.38,
    width: 45.65,
    height: 42.8,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.133333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 262.78
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 284.18,
    width: 45.65,
    height: 44.37,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.54625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 306.365
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 328.55,
    width: 45.65,
    height: 45.36,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4799999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 351.23
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 373.91,
    width: 45.65,
    height: 45.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.521428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 396.88500000000005
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 419.86,
    width: 45.65,
    height: 46.02,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.129999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 442.87
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 465.88,
    width: 45.65,
    height: 46.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 489
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 512.12,
    width: 45.65,
    height: 46.57,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.70625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 535.405
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 558.68,
    width: 45.65,
    height: 46.82,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.521428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 582.0899999999999
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 605.51,
    width: 45.65,
    height: 47.12,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.70625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 629.0699999999999
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 652.63,
    width: 45.65,
    height: 47.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.70625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.185,
    y: 676.3149999999999
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 75.5,
    width: 46.76,
    height: 47.58,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.39000000000001,
    y: 99.28999999999999
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.77,
    y: 75.5,
    width: 46.93,
    height: 47.58,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.235,
    y: 99.28999999999999
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.7,
    y: 75.5,
    width: 47.6,
    height: 47.58,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.5,
    y: 99.28999999999999
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.31,
    y: 75.5,
    width: 48.38,
    height: 47.58,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.5,
    y: 99.28999999999999
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.68,
    y: 75.5,
    width: 48.48,
    height: 47.58,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.92,
    y: 99.28999999999999
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.16,
    y: 75.5,
    width: 49.15,
    height: 47.58,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.797142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.735,
    y: 99.28999999999999
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.31,
    y: 75.5,
    width: 49.82,
    height: 47.58,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.286666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.22,
    y: 99.28999999999999
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.13,
    y: 75.5,
    width: 50.27,
    height: 47.58,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.265,
    y: 99.28999999999999
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.4,
    y: 75.5,
    width: 50.62,
    height: 47.58,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.7099999999999,
    y: 99.28999999999999
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.02,
    y: 75.5,
    width: 50.73,
    height: 47.58,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.385,
    y: 99.28999999999999
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.75,
    y: 75.5,
    width: 51.19,
    height: 47.58,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.797142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.345,
    y: 99.28999999999999
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.94,
    y: 75.5,
    width: 52.06,
    height: 47.58,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.97,
    y: 99.28999999999999
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 123.08,
    width: 54.49,
    height: 45.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.172
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 146.01
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 168.94,
    width: 54.49,
    height: 46.93,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 192.405
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 215.86,
    width: 54.49,
    height: 47.51,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.918333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 239.615
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 263.38,
    width: 54.49,
    height: 49.38,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.876000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 288.07
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 312.76,
    width: 54.49,
    height: 53.4,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 339.46
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 366.16,
    width: 54.49,
    height: 53.77,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6814285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 393.045
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 419.93,
    width: 54.49,
    height: 55.15,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 447.505
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 475.08,
    width: 54.49,
    height: 55.7,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 502.93
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 530.78,
    width: 54.49,
    height: 55.79,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.081666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 558.675
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 586.57,
    width: 54.49,
    height: 56.1,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 614.62
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 642.67,
    width: 54.49,
    height: 57.33,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.81125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.255,
    y: 671.3349999999999
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 123.08,
    width: 56.64,
    height: 56.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.82,
    y: 151.575
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.14,
    y: 123.08,
    width: 56.72,
    height: 56.99,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.5,
    y: 151.575
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.86,
    y: 123.08,
    width: 59.66,
    height: 56.99,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.12375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.69,
    y: 151.575
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.52,
    y: 123.08,
    width: 60.1,
    height: 56.99,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.141428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.57,
    y: 151.575
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.62,
    y: 123.08,
    width: 60.21,
    height: 56.99,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.141428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.725,
    y: 151.575
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.83,
    y: 123.08,
    width: 60.42,
    height: 56.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.12375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.03999999999996,
    y: 151.575
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.25,
    y: 123.08,
    width: 61.04,
    height: 56.99,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.141428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.77,
    y: 151.575
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.28,
    y: 123.08,
    width: 61.18,
    height: 56.99,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.498333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.87,
    y: 151.575
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.47,
    y: 123.08,
    width: 61.53,
    height: 56.99,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.141428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.235,
    y: 151.575
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 180.07,
    width: 57.43,
    height: 61.87,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.571666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 211.005
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 241.94,
    width: 57.43,
    height: 63.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.571666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 273.59
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 305.24,
    width: 57.43,
    height: 63.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 337.08
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 368.92,
    width: 57.43,
    height: 64.17,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.204285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 401.005
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 433.09,
    width: 57.43,
    height: 64.96,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.571666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 465.57
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 498.05,
    width: 57.43,
    height: 66.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.204285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 531.17
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 564.29,
    width: 57.43,
    height: 67.75,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.381111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 598.165
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 632.04,
    width: 57.43,
    height: 67.96,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.571666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 666.02
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 180.07,
    width: 65.41,
    height: 60.84,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 252.635,
    y: 210.49
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.34,
    y: 180.07,
    width: 66.04,
    height: 60.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.35999999999996,
    y: 210.49
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.38,
    y: 180.07,
    width: 66.98,
    height: 60.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.87,
    y: 210.49
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.36,
    y: 180.07,
    width: 68.68,
    height: 60.84,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.70000000000005,
    y: 210.49
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.04,
    y: 180.07,
    width: 69.7,
    height: 60.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.89,
    y: 210.49
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.73,
    y: 180.07,
    width: 70.79,
    height: 60.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0840000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.125,
    y: 210.49
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.53,
    y: 180.07,
    width: 72.47,
    height: 60.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.691428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.765,
    y: 210.49
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 240.91,
    width: 70.4,
    height: 62.79,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.13,
    y: 272.305
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 303.7,
    width: 70.4,
    height: 63.62,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.603333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.13,
    y: 335.51
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 367.32,
    width: 70.4,
    height: 64.48,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.164444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.13,
    y: 399.56
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 431.8,
    width: 70.4,
    height: 65.9,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.983333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.13,
    y: 464.75
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 497.71,
    width: 70.4,
    height: 66.38,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.063333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.13,
    y: 530.9
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 564.09,
    width: 70.4,
    height: 67.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.13,
    y: 597.645
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.93,
    y: 631.2,
    width: 70.4,
    height: 68.8,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.13,
    y: 665.6
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 240.91,
    width: 64.88,
    height: 74.74,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.77,
    y: 278.28
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.21,
    y: 240.91,
    width: 65.44,
    height: 74.74,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.92999999999995,
    y: 278.28
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 240.91,
    width: 65.55,
    height: 74.74,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.364285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.42499999999995,
    y: 278.28
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 486.2,
    y: 240.91,
    width: 70.38,
    height: 74.74,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.39,
    y: 278.28
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.58,
    y: 240.91,
    width: 71.14,
    height: 74.74,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.1500000000001,
    y: 278.28
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.72,
    y: 240.91,
    width: 72.28,
    height: 74.74,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.03111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.86,
    y: 278.28
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 315.64,
    width: 78.06,
    height: 69.93,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.36,
    y: 350.605
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 385.57,
    width: 78.06,
    height: 72.09,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.36,
    y: 421.615
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 457.66,
    width: 78.06,
    height: 73.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.36,
    y: 494.38
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 531.09,
    width: 78.06,
    height: 75.26,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.36,
    y: 568.72
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 606.35,
    width: 78.06,
    height: 93.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.151428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.36,
    y: 653.1750000000001
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.4,
    y: 315.64,
    width: 102,
    height: 89.65,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.20625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.4,
    y: 360.465
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.39,
    y: 315.64,
    width: 114.08,
    height: 89.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.43,
    y: 360.465
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 584.47,
    y: 315.64,
    width: 115.53,
    height: 89.65,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.4125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 642.235,
    y: 360.465
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.4,
    y: 405.3,
    width: 92.84,
    height: 140.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.82,
    y: 475.6
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.4,
    y: 545.9,
    width: 92.84,
    height: 154.1,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.82,
    y: 622.9499999999999
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.24,
    y: 405.3,
    width: 238.76,
    height: 78.89,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.62,
    y: 444.745
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.24,
    y: 484.19,
    width: 238.76,
    height: 215.81,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 35.968333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.62,
    y: 592.095
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1936);
export default __webpack_public_path__ + "static/media/1936.a23688deae87ffd1b6eb74c350b5c36d.svg";
export { ForwardRef as ReactComponent };